import tippy from 'tippy.js';

const initAboutFlat = (parent: HTMLElement): void => {
    if (!parent) {
        console.warn(`Parent is ${parent}`);

        return;
    }

    const attributes = {
        tagText: 'data-text'
    };

    const tagsWrapper = parent.querySelector('.about-flat__tags') as HTMLElement;
    const tagsEl = [].slice.call(parent.querySelectorAll('.about-flat__tag'))
        .filter((node: HTMLElement) => {
            return node.hasAttribute(attributes.tagText);
        });

    if (tagsEl.length) {
        tippy(tagsEl, {
            appendTo              : 'parent',
            arrow                 : false,
            placement             : 'bottom-start',
            offset                : [0, 2],
            maxWidth              : 'none',
            allowHTML             : true,
            getReferenceClientRect: () => {
                return tagsWrapper.getBoundingClientRect();
            },
            content(ref) {
                return `${ref.getAttribute(attributes.tagText)}`;
            }
        });
    }
};

export default initAboutFlat;
